import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Alert, Button, Stack
} from "@mui/material";
import { Output } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";

import { MindsetInsightSkeleton } from "./MindsetInsightSkeleton";
import { PageContainer } from "@/components/containers";
import { InsightLayout } from "@/components/layouts";
import { MindsetPenPortraitView } from "@/components/molecules";
import { InsightMetaProvider } from "@/context";
import { useInsight } from "@/hooks";
import { TabOption } from "@/types";

const MindsetSegmentInsightPage: React.FC = () => {

  let { audienceId } = useParams<{ audienceId: string }>();
  const { audience, insight, loading, error } = useInsight(audienceId, true);
  const navigate = useNavigate();

  const segmentNum = 0;

  const mindsetInsightTab: TabOption = {
    showScores: true,
    showLevels: false,
    showSearch: false,
    showSorts: false,
    showDownload: false,
  };

  const handleUpdateDescription = async (text: string) => {
    return Promise.resolve();
  };

  const handleRefreshDescription = async () => {
    return insight?.meta[segmentNum].description_short;
  }

  const actionButtons = (
    <Stack direction="row" spacing={2}>
      <Button
        variant="contained"
        size="small"
        disableElevation
        startIcon={<Output />}
        onClick={() => navigate("export")}
      >
        Export
      </Button>
    </Stack>
  );

  return (
    <PageContainer
      actions={actionButtons}
      loading={loading}
      loadingText={"Loading Mindset Insight"}
    >
      {loading ? (
        <MindsetInsightSkeleton />
      ) : (
        <Grid container spacing={2} flexDirection="column" flexGrow={1} pb={8}>
          {error && (
            <Grid>
              <Alert variant="filled" severity="error">
                {error}
              </Alert>
            </Grid>
          )}
          {audience && (
            <>

              {insight &&
                <InsightLayout
                  tab={mindsetInsightTab}
                  title={audience.audience_name}
                  summary={audience.audience_size && audience.audience_size[segmentNum]}
                  onDownload={() => null}
                >
                  <InsightMetaProvider
                    handleUpdateDescription={handleUpdateDescription}
                    handleRefreshDescription={handleRefreshDescription}
                  >
                    <MindsetPenPortraitView
                      mindset={{ segment_id: 0, segment_name: audience.audience_name }}
                      meta={insight.meta[segmentNum]}
                      insights={insight.insights[segmentNum]}
                      pen_portrait={insight.pen_portraits[segmentNum]}
                      locations={insight.locations[segmentNum]}
                      editable={false}
                    />
                  </InsightMetaProvider>
                </InsightLayout>
              }
            </>
          )}
        </Grid>
      )}
    </PageContainer>
  );
};

export default MindsetSegmentInsightPage;
